import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { RealtimeSettlementOrderDailySumFilterType } from '../graphql/types/RealtimeSettlementOrderDailySumType';
import { ChannelSelectFilter } from '../../../../../components/settlement/ChannelSelectFilter';
import DateRangeFilterItem from "../../../../delivery/components/DateRangeFilterItem";
import { hasResource } from '../../../../../utils/resourceAuth';
import { ResourceCode } from '../../../../../constants/resourceCodes';

interface RealtimeSettlementOrderDailySumFilterProps {
    filters: RealtimeSettlementOrderDailySumFilterType;
    setFilters: (filters: RealtimeSettlementOrderDailySumFilterType) => void;
    handleFilter: () => void;
    handleResetFilters: () => void;
    downloadLoading?: boolean;
    onDownload?: () => void;
}

const RealtimeSettlementOrderDailySumFilter: React.FC<RealtimeSettlementOrderDailySumFilterProps> = ({
    filters,
    setFilters,
    handleFilter,
    handleResetFilters,
    downloadLoading,
    onDownload,
}) => {
    const canView = hasResource([ResourceCode.settlement.SETTLEMENT_REALTIME_EXPORT_DETAIL]);

    // 处理时间变化的函数 - 转换为YYYYMMDD格式
    const handleDailyDateChange = (
        dates: [string | null, string | null] | null
    ) => {
        if (dates) {
            const startDate = dates[0] ? dates[0].replace(/[-/]/g, '') : null;
            const endDate = dates[1] ? dates[1].replace(/[-/]/g, '') : null;
            setFilters({
                ...filters,
                dailyDateStart: startDate,
                dailyDateEnd: endDate
            });
        } else {
            setFilters({
                ...filters,
                dailyDateStart: null,
                dailyDateEnd: null
            });
        }
    };

    // 将YYYYMMDD格式转换回YYYY-MM-DD用于显示
    const getDailyDateValue = (): [string | null, string | null] | null => {
        if (filters.dailyDateStart || filters.dailyDateEnd) {
            const formatDate = (date: string | null | undefined) => {
                if (!date) return null;
                const str = date.toString();
                if (str.length === 8) {
                    return `${str.substring(0, 4)}-${str.substring(4, 6)}-${str.substring(6, 8)}`;
                }
                return date;
            };
            return [
                formatDate(filters.dailyDateStart),
                formatDate(filters.dailyDateEnd)
            ];
        }
        return null;
    };

    return (
        <div className="mb-6">
            <div className="grid grid-cols-3 gap-x-4 gap-y-3 mb-4">
                <ChannelSelectFilter
                    multiple
                    label="客户名称"
                    value={filters.clientIds?.map(String)}
                    onChange={(value: string[] | undefined) => setFilters({
                        ...filters,
                        clientIds: value?.length ? value.map(Number) : undefined
                    })}
                    spanClassName="w-[9em]"
                />
                <DateRangeFilterItem
                    label="时间范围"
                    value={getDailyDateValue()}
                    onChange={handleDailyDateChange}
                    spanClassName="w-[9em]"
                />
            </div>

            <div className="mb-4 flex justify-start">
                <div className="space-x-4">
                    {canView && (
                        <Button type="primary" onClick={handleFilter}>
                            Filter
                        </Button>
                    )}
                    {canView && (
                        <Button onClick={handleResetFilters}>
                            Reset
                        </Button>
                    )}
                    {canView && onDownload && (
                        <Button icon={<DownloadOutlined />} loading={downloadLoading} onClick={onDownload}>
                            导出数据
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RealtimeSettlementOrderDailySumFilter;
